import secondaryButtonRule from '../../secondary-button/branded-solid/background/default';

const secondary = (params) => secondaryButtonRule.secondary(params);

export default secondary;
